<template>
  <Loading v-if="!fullyLoaded" />
  <SiteForm
    v-else
    :manufacturers="manufacturers"
    :abilities="abilities"
    :resource="resource"
    :submit="submit"
    :destroy="destroy"
    :cancel="cancel"
  />
</template>

<script>
import EditView from '@/mixins/editView';
import ResourceService from '@/services/resources/sites_service';
import ManufacturerService from '@/services/resources/chemical_manufacturers_service';
import SiteAbilityService from '@/services/resources/site_abilities_service';
import AbilityService from '@/services/resources/abilities_service';

export default {
  mixins: [EditView],
  components: {
    SiteForm: () => import('@/components/forms/SiteForm.vue'),
  },
  data() {
    return {
      resourceParams: {
        include: 'chemical-manufacturer,site-abilities.ability',
      },
      urlFragment: 'sites',
      resourceService: ResourceService,
    };
  },
  asyncComputed: {
    manufacturers: {
      get() {
        return ManufacturerService.index().then((manufacturers) => {
          return manufacturers.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
    abilities: {
      get() {
        return AbilityService.index().then((abilities) => {
          return abilities.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
  methods: {
    submit(resource) {
      const { siteAbilities, ...siteAttributes } = resource;
      return this.resourceService
        .update(siteAttributes)
        .then((site) => {
          const abilityPromises = siteAbilities.map((ability) => {
            ability.site = site.data;
            if (ability.id) {
              if (ability.toDelete) {
                return SiteAbilityService.destroy(ability);
              } else {
                return SiteAbilityService.update(ability);
              }
            } else {
              return SiteAbilityService.create(ability);
            }
          });

          return Promise.all([...abilityPromises]).then(() => {
            const { name } = site.data;
            this.successToast(`Updated ${name}`);
            this.$router.push(this.destination);
          });
        })
        .catch(this.failToast);
    },
  },
};
</script>
